/* eslint-disable promise/param-names */
import {
  AUTHORS_REQUEST,
  AUTHOR_REQUEST_BY_ID,
  AUTHORS_REPLACE,
  AUTHORS_SUCCESS,
  AUTHOR_GET_NEW_ID,
  AUTHOR_SAVE,
  AUTHOR_UPDATE,
} from '@/store/actions/authors';

import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import Vue from 'vue';

import {sleep} from '@/utils/utils.js'

const state = { 
  authors: [],
  status: '', 
  hasLoadedOnce: false,
};

const getters = {
  authors: state => state.authors ? state.authors : [],
  authorsLoaded: state => { 
    return state.hasLoadedOnce
  }
};

const actions = {
  [AUTHORS_REQUEST]: ({commit, dispatch}) => {
    if (!state.hasLoadedOnce) {
      return new Promise((resolve, reject) => {
        commit(AUTHORS_REQUEST)
      
        firebase.firestore().collection('authors').orderBy('name')
          .onSnapshot(querySnapshot => {
            let authors = []

            querySnapshot.docChanges().forEach(change => {
              authors.push(change.doc.data())
            })

            if (state.hasLoadedOnce == false) {
              commit(AUTHORS_SUCCESS, authors)
            } else {
              commit(AUTHORS_REPLACE, authors)
            }

            resolve();
          })
      })
    }
  },

  [AUTHOR_REQUEST_BY_ID]: ({commit, dispatch}, authorId) => {
    return new Promise(async (resolve, reject) => {
      if (!state.hasLoadedOnce) {
        while (state.status === 'loading') {
          await sleep(300)
        }

        let author = state.authors.find(elem => elem.id == authorId)

        if (author != undefined) {
          resolve(JSON.parse(JSON.stringify(author)))
        } else {
          reject('not found')
        }
      } else {
        let author = state.authors.find(elem => elem.id == authorId)

        if (author != undefined) {
          resolve(JSON.parse(JSON.stringify(author)))
        }

        reject('not found')
      }
    })
  },

  [AUTHOR_SAVE]: ({commit, dispatch}, author) => {
    commit(AUTHORS_REQUEST)

    if (author.id === undefined) {
      throw new Error(`Id can't be undefined`);
    }

    return firebase.firestore().collection("authors").doc(String(author.id)).set(author)
        .catch(err => {
          console.error(err);
        })
  },

  [AUTHOR_UPDATE]: ({commit, dispatch}, author) => {
    commit(AUTHORS_REQUEST)

    return firebase.firestore().collection("authors").doc(String(author.id)).update(author)
        .catch(err => {
          console.error(err)
        })
  },

  [AUTHOR_GET_NEW_ID]: ({commit, dispatch}) => {
    commit(AUTHORS_REQUEST)

    return new Promise( (resolve, reject) => {
      var getNewAuthorId = firebase.functions().httpsCallable('getNewAuthorId');
      getNewAuthorId().then(result => {
        commit(AUTHORS_SUCCESS)
        resolve(result.data)
      }).catch(err => {
        reject(err)
      })
    });
  },
}


const mutations = {
  [AUTHORS_REQUEST]: (state) => {
    state.status = 'loading';
  },

  [AUTHORS_SUCCESS]: (state, authors) => {
    state.status = 'success';

    if (authors != undefined) {
      state.authors = authors;
      state.hasLoadedOnce = true;
    }
  },

  [AUTHORS_REPLACE]: (state, authors) => {
    authors.forEach(author => {
      let rowIndex = state.authors.findIndex(elem => elem.id == author.id)
      if (rowIndex != -1) {
        Vue.set(state.authors, rowIndex, author)
      } else {
        state.authors.push(author)
      }
    })
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
